/**
 * Free-gift popup (blocks/bn-free-gift.liquid): the row opens a modal <dialog> with a swipeable
 * carousel of the gift images. Native dialog = Esc closes and focus is trapped; a click on the
 * backdrop closes too. Arrows scroll one slide; dots follow the scroll position.
 */
class BnGiftPopup extends HTMLElement {
  connectedCallback() {
    this.dialog = this.querySelector('dialog');
    this.track = this.querySelector('[data-track]');
    this.dots = [...this.querySelectorAll('.bn-gift-dialog__dot')];
    this.addEventListener('click', this.#onClick);
    this.dialog?.addEventListener('click', this.#onBackdrop);
    this.track?.addEventListener('scroll', this.#onScroll, { passive: true });
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.#onClick);
    this.dialog?.removeEventListener('click', this.#onBackdrop);
    this.track?.removeEventListener('scroll', this.#onScroll);
  }

  #onClick = (event) => {
    const target = event.target instanceof Element ? event.target : null;
    if (!target || !this.dialog) return;
    if (target.closest('[data-open]')) {
      this.track?.scrollTo({ left: 0 });
      this.#setDot(0);
      this.dialog.showModal();
    } else if (target.closest('[data-close]')) {
      this.dialog.close();
    } else if (target.closest('[data-next]')) {
      this.#go(1);
    } else if (target.closest('[data-prev]')) {
      this.#go(-1);
    }
  };

  // a click on the dialog element itself (not its content) is a click on the backdrop
  #onBackdrop = (event) => {
    if (event.target === this.dialog) this.dialog.close();
  };

  #go(step) {
    if (!this.track) return;
    const width = this.track.clientWidth;
    const count = this.track.children.length;
    const index = Math.round(this.track.scrollLeft / width);
    const next = (index + step + count) % count;
    this.track.scrollTo({ left: next * width, behavior: 'smooth' });
  }

  #onScroll = () => {
    if (!this.track || !this.dots.length) return;
    this.#setDot(Math.round(this.track.scrollLeft / this.track.clientWidth));
  };

  #setDot(index) {
    this.dots.forEach((dot, i) => dot.classList.toggle('is-on', i === index));
  }
}

if (!customElements.get('bn-gift-popup')) customElements.define('bn-gift-popup', BnGiftPopup);
